// import axios from "axios";

// const instance = axios.create({
//   baseURL: process.env.REACT_APP_APIBASE + "/",
//   timeout: 900000,
//   headers: {
//     "Content-Type": "Application/json",
//     Accept: "application/json",
//     "Access-Control-Allow-Origin": "*",
//     Authorization: localStorage.getItem("token"),
//   },
// });

// instance.interceptors.request.use(function (config) {
//   let token = localStorage.getItem("token");
//   config.headers["Authorization"] = token;
//   return config;
// });

// export default class AxiosServices {
//   Post(url, data) {
//     return instance.post(url, data);
//   }

//   Get(url, params) {
//     return instance.get(url, params);
//   }

//   Delete(url, data) {
//     return instance.delete(url, {
//       data: data,
//       headers: {
//         "content-Type": "Application/json",
//         Accept: "application/json",
//         "Access-Control-Allow-Origin": "*",
//         Authorization: localStorage.getItem("token"),
//       },
//     });
//   }

//   Put(url, data, params, isHeaderRequired, header) {
//     return instance.put(url, data, {
//       params: params,
//       headers: {
//         "content-Type": "Application/json",
//         Accept: "application/json",
//         "Access-Control-Allow-Origin": "*",
//         Authorization: localStorage.getItem("token"),
//       },
//     });
//   }

//   Patch(url, data) {
//     return instance.patch(url, data);
//   }
// }

// src/services/axiosServices.js
import axios from "axios";
import { showError } from "../constants/utility";
// Create axios instance
const instance = axios.create({
  baseURL: process.env.REACT_APP_APIBASE + "/", // Your backend base URL
  timeout: 900000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor → attach latest token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor → handle global errors/logging if needed
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      switch (status) {
        // handled indivual errors
        // case 400:
        //   console.error("Bad Request:", error.response.data);
        //   showError( error.response.data.error || "Invalid request. Please check your input.");
        //   break;

        case 401:
          console.warn("Unauthorized: Redirecting to login");
          showError("Your session has expired. Please log in again.");
          // Optional: auto logout or redirect
          // localStorage.removeItem("token");
          // window.location.href = "/";
          break;

        // case 403:
        //   showError("You don't have permission to perform this action.");
        //   break;

        // case 404:
        //   showError("Requested resource not found.");
        //   break;

        // case 500:
        // case 502:
        // case 503:
        //   showError("Server is currently unavailable. Please try again later.");
        //   break;

        default:
          // showError("An unexpected error occurred. Please try again.");
          break;
      }
    } else if (error.request) {
      // No response (network error, timeout, etc.)
      console.error("Network Error:", error);
      showError("Network error. Please check your connection.");
    } else {
      console.error("Error Setting Up Request:", error);
      showError("Unexpected error. Please try again.");
    }

    console.error("API Error:", error.response || error.message);
    return Promise.reject(error);
  }
);

export default class AxiosService {
  static Get(url, config = {}) {
    return instance.get(url, config);
  }

  static Post(url, data, config = {}) {
    return instance.post(url, data, config);
  }

  static Put(url, data, config = {}) {
    return instance.put(url, data, config);
  }

  static Patch(url, data, config = {}) {
    return instance.patch(url, data, config);
  }

  static Delete(url, data = {}, config = {}) {
    return instance.delete(url, {
      data,
      ...config,
    });
  }
}
